<mat-tab-group class="smp-tab-style mt-4 mb-4 full-width">

    <!-- DOCUMENTS -->
    <mat-tab id="{{idPrefix}}tab.documentation" label="Documentation">
        <!-- FIRST ROW -->
        <div class="row no-gutters">

            <!-- FIRST ROW - FIRST COLUMN - LAWYER COMMENTS -->
            <div class="col-sm-8 pr-3">

                <editable-comments [idPrefix]="(idPrefix + 'comments.')"
                                   [comments]="commentsList?.items"
                                   [disabled]="disabled"
                                   (create)="createComment($event)"
                                   (update)="updateComment($event)"
                                   (remove)="deleteComment($event)">
                </editable-comments>

            </div>


            <!-- FIRST ROW - SECOND COLUMN - DROPZONE DOCUMENTS LIST -->
            <div class="col-sm-4 pl-3">

                <div class="smp-title mb-4">{{ 'detailed_processing.lawyer.title.lawyer_documents' | translate }}</div>

                <case-files-upload class="full-width"
                                   *ngIf="caseId && fileMetaCategoryList"
                                   [idPrefix]="idPrefix"
                                   [caseId]="caseId"
                                   [(fileMetaCategoryList)]="fileMetaCategoryList"
                                   [smpFileCategory]="accidentDocumentCategory"
                                   [role]="Role.SMP_LAWYER"
                                   [dropzoneLabel]="'detailed_processing.lawyer.label.upload_lawyer_document' | translate"
                                   [addButtonLabel]="'detailed_processing.lawyer.label.upload_lawyer_document' | translate"
                                   [acceptedFiles]="acceptedFileTypes"
                                   [hasContent]="fileMetaCategoryList?.getFilesByCategory(accidentDocumentCategory)?.entries.length > 0">

                    <!-- only works with a dropzone. List is displayed inside the dropzone (if it has files) -->
                    <case-files-list class="full-width"
                                     [idPrefix]="idPrefix"
                                     [caseId]="caseId"
                                     [(fileMetaCategoryList)]="fileMetaCategoryList"
                                     [smpFileCategory]="accidentDocumentCategory">
                    </case-files-list>

                </case-files-upload>

            </div>

        </div>
    </mat-tab>

    <!-- PAYMENTS -->
    <mat-tab id="{{idPrefix}}tab.payments" label="{{ 'detailed_processing.summary.title.payments' | translate }}">
        
        <case-lawyer-payment [idPrefix]="(idPrefix + 'payments.')"
                             [caseId]="caseId">
        </case-lawyer-payment>

    </mat-tab>

</mat-tab-group>
